import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// --- Interfaces ---
import type { ICart, ICartLocalStorage } from '@interfaces/cart';

export interface ICartState extends ICart {}
export interface ICartLocalState extends ICartLocalStorage {}

export const INITIAL_STATE: ICartState = {
	metadata: {
		page: 0,
		pageLimit: 0,
		count: 0,
		totalItems: 0,
	},
	result: [],
	userId: 0,
	total: 0,
};

export const INITIAL_STATE_LOCAL: ICartLocalState = {
	products: [],
	totalItems: 0,
	total: 0,
};

@Injectable({
	providedIn: 'root',
})
export class CartStore {
	private _cartState = new BehaviorSubject<ICartState>(INITIAL_STATE);
	readonly cartState$ = this._cartState.asObservable();

	private _cartStateLocal = new BehaviorSubject<ICartLocalState>(
		INITIAL_STATE_LOCAL
	);
	readonly cartStateLocal$ = this._cartStateLocal.asObservable();

	constructor() {}

	updateCart(cart: ICartState) {
		const state = this._cartState.value;

		const data = {
			...state,
			...cart,
		};

		this._cartState.next(data);

		return this._cartState.asObservable();
	}

	updateCartLocal(cart: ICartLocalState) {
		const state = this._cartStateLocal.value;

		const data = {
			...state,
			...cart,
		};

		this._cartStateLocal.next(data);

		return this._cartStateLocal.asObservable();
	}
}
